import Td from './Td'

type TrType = {
    dataItem: unknown[] | Record<string, unknown>
    deleteById?: (id: number) => void
    id: number
}

const Tr = ({ dataItem, deleteById, id }: TrType) => {
    const dataArray = Array.isArray(dataItem) ? dataItem : Object.entries(dataItem).map(([key, value]) => [key, value])

    return (
        <tr>
            {dataArray.map((singleData, index) => (
                <Td key={`td${index}`} singleData={singleData as any[]} id={id} deleteById={deleteById} />
            ))}
        </tr>
    )
}

export default Tr
